import styled, { keyframes, css } from "styled-components";

export const shimmerAnimation = keyframes`
    0% { background-position: -1000px 0; }
    100% { background-position: 1000px 0; }
`;

export const gradientShimmerMixin = css`
    background: linear-gradient(90deg, #e2e2e7 0%, #d0d1d7 52.08%, #e2e2e7 100%);
    background-size: 1000px 100%;
    animation: ${shimmerAnimation} 2s infinite linear;
`;

export const OrderContainer = styled.div`
    border-radius: 0 0 24px 24px;
    background: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    padding: 20px;
`;

export const SingleLine = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const Circle = styled.div`
    ${gradientShimmerMixin}
    width: 20px;
    height: 20px;
    border-radius: 20px;
`;

export const LineShimmer = styled.div<{ widthPercent?: number }>`
    ${gradientShimmerMixin}
    width: ${({ widthPercent }) => widthPercent ?? 50}%;
    height: 16px;
    margin-left: 18px;
`;

export const Square = styled.div`
    ${gradientShimmerMixin}
    width: 32px;
    height: 32px;
    border-radius: 8px;
`;

export const Rectangle = styled.div`
    ${gradientShimmerMixin}
    border-radius: 12px;
    height: 60px;
    margin: 0 16px;
`;

export const TitleShimmer = styled.div<{ widthPercent?: number }>`
    ${gradientShimmerMixin}
    height: 16px;
    margin: 46px 0 30px 20px;
    width: ${({ widthPercent }) => widthPercent ?? 30}%;
`;

export const PaymentMethodContainer = styled.div`
    box-shadow: 0px 1px 16px rgba(0, 0, 0, 0.05);
    border-radius: 16px;
    margin: 16px;
    background: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    padding: 16px 0;

    &:last-child {
        margin-bottom: 5px;
    }
`;

export const PaymentMethodRow = styled.div`
    display: flex;
    flex: 1;
    padding: 21px 0;
    border-bottom: 1px solid rgba(235, 235, 240, 0.5);
    justify-content: space-evenly;
    align-items: center;

    &:first-child {
        padding-top: 5px;
    }

    &:last-child {
        padding-bottom: 5px;
        border-bottom: none;
    }
`;

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 20px 16px 20px 4px;
`;
